<template lang="pug">
  f7-popup(:opened="opened")
    f7-page
      dark-popup-navigation-bar(@close="$emit('close')")
      background
        video-view(:video-url="videoUrl")
</template>

<style lang="scss" scoped>
@media (min-height: 630px) and (min-width: 630px) {
  .popup:not(.popup-tablet-fullscreen) {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: 0;
    margin-top: 0;
  }
}
</style>

<script>
import DarkPopupNavigationBar from '@/components/molecules/DarkPopupNavigationBar'
import VideoView from '@/components/organisms/VideoView'

export default {
  components: { DarkPopupNavigationBar, VideoView },
  props: {
    opened: { type: Boolean },
    src: { type: String },
  },
  data() {
    return {
      videoUrl: null,
    }
  },
  watch: {
    opened: function (val) {
      if (val) {
        this.videoUrl = this.src
      } else {
        this.videoUrl = null
      }
    },
  },
}
</script>
